import { Service, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DoorDataService } from '@data-services/doors';
import { Door } from '@models/doors';
import { DataContext } from '@services/data-context';
import { createPageResource } from '@utils';

@Service({ autoProvided: false })
export class ProjectDoorsService {
  private readonly doorDataService = inject(DoorDataService);
  private readonly dataContext = inject(DataContext);
  private readonly translate = inject(TranslateService);

  readonly resource = createPageResource<Door[], string>({
    params: () => this.dataContext.projectContext()?.id,
    loadAsync: (projectId) => this.doorDataService.getDoorsAsync(projectId),
    errorMessage: () => this.translate.instant('general.loadDoorsError'),
    fallbackValue: []
  });
}
